export default "__VITE_ASSET__f4d33e3c__"